import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext } from '../../../context';

import AddComment from '../../forms/add-comment';
import CommentDetail from '../comment-detail';

import style from './index.module.scss';

function Comments({ questionId, answerId, commentList }) {
  const { isAuthenticated, currentUser } = useContext(AuthContext);

  return (
    <section className={style.comments}>
      {isAuthenticated ? (
        <AddComment questionId={questionId} answerId={answerId} currentUser={currentUser} />
      ) : (
        <p>
          <Link to="/account/login">Sign in</Link> to be able to comment
        </p>
      )}
      {commentList.map(comment => (
        <CommentDetail key={comment.id} comment={comment} />
      ))}
    </section>
  );
}

Comments.defaultProps = {
  commentList: [],
};

Comments.propTypes = {
  questionId: PropTypes.string,
	answerId: PropTypes.string,
  commentList: PropTypes.array.isRequired,
};

export default Comments;
